<template>
	<div>
		<core-stakeholders-card
			:caseId="caseId"
			:proposalId="proposalId"
			:stakeholders="stakeholders"
			stakeholdersOf="proposal"
			@stakeholder:added="fetchStakeholders"
			@stakeholder:removed="removeStakeholder"
			variant="no-headline"
			:types="types"
		/>
	</div>
</template>

<script>
import CoreStakeholdersCard from "@/modules/core/components/CoreStakeholdersCard/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreStakeholdersCard },

	props: {
		types: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			stakeholders: []
		}
	},

	computed: {
		caseId() {
			return this.$store.state.caseManagement.caseId
		},
		proposalId() {
			return this.$store.state.caseManagement.proposalId
		}
	},

	methods: {
		async fetchStakeholders() {
			const query = gql`
				query proposalStakeholders(
					$caseWhere: caseWhere
					$proposalWhere: proposalWhere
				) {
					cases(where: $caseWhere) {
						list {
							proposals(where: $proposalWhere) {
								stakeholders {
									id
									type
									entity {
										id
										name
									}
								}
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: {
					caseWhere: { id: this.caseId },
					proposalWhere: { id: this.proposalId }
				}
			})

			this.stakeholders =
				res?.data?.cases?.list?.[0]?.proposals?.[0]?.stakeholders
		},

		removeStakeholder(stakeholderId) {
			this.stakeholders = this.stakeholders.filter(
				item => item.id !== stakeholderId
			)
		}
	},

	watch: {
		// When store updates, refetch stakeholders
		"$store.state.caseManagement.proposalId": {
			handler() {
				this.fetchStakeholders()
			},
			immediate: true
		}
	}
}
</script>
